export default "__VITE_ASSET__C5AAB1jk__"